import scrollLock from '../helpers/scroll-lock';

const launch = (elSubject, opts) => {
	// build modal elements
	const elModal = document.createElement('div');
	elModal.setAttribute('class', 'basicmodal gutter');
	if (opts.className) {
		elModal.classList.add(`basicmodal--${opts.className}`);
	}
	const elRel = document.createElement('div');
	elRel.setAttribute('class', 'basicmodal-rel');
	const elWin = document.createElement('div');
	elModal.appendChild(elRel);
	elWin.setAttribute('class', 'basicmodal-window bg bg--white');
	elRel.appendChild(elWin);
	const closeEl = document.createElement('button');
	closeEl.setAttribute('class', 'basicmodal-close');
	closeEl.innerHTML = '<div class="basicmodal-x">×</div><div class="basicmodal-closetext">Close</div>';
	elWin.appendChild(closeEl);
	elSubject.removeAttribute('hidden');
	elWin.appendChild(elSubject);
	document.body.appendChild(elModal);
	scrollLock.enable();
	
	if (typeof window.add_form_validation === "function") {
		window.parent.add_form_validation();
	}
	// is tall enough to be offscreen?
	if (elRel.offsetTop <= 0) {
		elModal.classList.add('basicmodal--tall');
	}
	const findFormCaptcha = elModal.querySelector('.g-recaptcha');
	if(findFormCaptcha){
		const getFormCaptchaId = findFormCaptcha.id;
		if(getFormCaptchaId && window.grecaptcha){
			window.grecaptcha.render(findFormCaptcha)
		}
	}
	
	const close = () => {
		scrollLock.disable();
		window.grecaptcha.reset();
		elSubject.setAttribute('hidden', true);
		if (!opts.killUponClose) {
			document.body.appendChild(elSubject);
		}
		elModal.parentNode.removeChild(elModal);
	};

	// click close button
	closeEl.addEventListener('click', close);

	// close modal when click outside white box
	elModal.addEventListener('click', (event) => {
		let ancestorNode = event.target;
		while (ancestorNode) {
			if (ancestorNode === elWin) {
				return;
			}
			ancestorNode = ancestorNode.parentNode;
		}
		close();
	});

	return elModal;
};

const basicmodal = { launch };

export default basicmodal;
